module.exports = __webpack_public_path__ + "97e672bbcabb94cdadac7f7368b13821.png";